/* @ngInject */
const myRadioMenu = (
  $state
) => {
  return {
    restrict: 'E',
    scope: {
      myMenu: '=',
      local: '=?',
    },

    template: require('./myRadioMenu.html'),

    /* @ngInject */
    controller: (
      $scope,
      $state
    ) => {
      $scope.changeState = (newState) => {
        const stateName = $state.current.name
        const stateParts = stateName.split('.')
        const statePart = stateParts[1]

        for (const key in $scope.myMenu.items) {
          const item = $scope.myMenu.items[key]
          if (item) {
            if (newState === item.ref) {
              $scope.title = item.label
              if (statePart !== item.ref) {
                item.go()
              }
            }
          }
        }
      }
    },
    link: {
      pre: (scope, element, attrs, ctrl) => {
        const itemCount = Object.keys(scope.myMenu.items).length

        let scol = 6
        let mcol = 3
        let lcol = 2

        if (itemCount < (12 / scol)) {
          scol = Math.ceil((12 / itemCount))
        }
        if (itemCount < (12 / mcol)) {
          mcol = Math.ceil((12 / itemCount))
        }
        if (itemCount < (12 / lcol)) {
          lcol = Math.ceil((12 / itemCount))
        }

        scope.layout = 'col s' + scol + ' m' + mcol + ' l' + lcol

        const stateName = $state.current.name
        const stateParts = stateName.split('.')
        const itemName = stateParts[2]
        if (itemName && !scope.local) {
          scope.myMenu.radio.value = itemName
        }
      },
      post: (scope, element, attrs, ctrl) => {

      },
    },
  }
}

export default myRadioMenu



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/directives/menus/myRadioMenu.js